export const CHECK_PRODUCT_ERROR = {
  UserLimitReachedProduct: 861,
  GlobalLimitReachedProduct: 862,
} as const

export const ProductErrorType = {
  status861: 'userLimitReachedProduct',
  status862: 'globalLimitReachedProduct',
} as const

export type ProductError = (typeof ProductErrorType)[keyof typeof ProductErrorType]

export const ProductErrorOrderType = {
  status861: 'productLimitExceeded',
  status862: 'globalLimitExceeded',
} as const
